import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import processControls from './handlers/process-controls';

import { clsx } from '../../../utils';

import { FormConfig, FormSubmitElements } from '../model/form';
import createId from '../../../utils/id';

type FormProps = FormConfig;

const Form: LitheFC<FormProps> = (config) => {
  const {
    id = createId(),
    testId,
    controls,
    onSubmit,
    classes,
    buttons,
  } = config;

  const onFormSubmitHandler = (event: SubmitEvent) => {
    event.preventDefault();

    const data = controls.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: curr.value,
      }),
      {} as Record<string, string>
    );

    onSubmit(data);
  };
  const element: LitheElement<'form'> = [
    'form',
    {
      id,
      'data-testid': testId,
      class: ['form'],
      onsubmit: onFormSubmitHandler,
    },
    ['div', { class: clsx(classes.form) }, ...processControls(controls)],
    [
      'div',
      { class: clsx(classes.buttons) },
      ...([] as FormSubmitElements[]).concat(buttons),
    ],
  ];

  return element;
};

export default Form;
